<template lang="pug">
  .advance-settings
    v-container(style="max-width:600px")
      v-card.py-4.mt-4.mx-2(flat outlined)
        .header.px-4
          div.s1.basic800--text Analytics
          div.c1.basic600--text Analyze and measure your business performance
          div.c1.accent--text(@click="openLink('a')") Learn More

        v-divider.my-4
        v-layout.mx-4.mt-4
          div.my-auto
            v-card.elevation-0
              v-img(:src="require('@/assets/images/settings/logo_facebook_pixel.svg')" width=28)
          div.my-auto.ml-3.s1.basic800--text Facebook Pixel
          v-spacer
          v-chip.button-AA-tiny(label outlined color="black" small @click="openTrackerDialog('fb')") MANAGE
        v-divider.my-4
        v-layout.mx-4.mt-4
          div.my-auto.ml-1
            v-card.elevation-0
              v-img(:src="require('@/assets/images/settings/logo_analytics.svg')" width=19 contain)
          div.my-auto.ml-4.s1.basic800--text Google Analytics
          v-spacer
          v-chip.button-AA-tiny(label outlined color="black" small @click="openTrackerDialog('ga')") MANAGE

      v-card.py-4.mt-4.mx-2(flat outlined)
        .header.px-4
          div.s1.basic800--text E-commerce Integrations
          div.c1.basic600--text Integrate with your current e-commerce system
          div.c1.accent--text(@click="openLink('e')") Learn More

        div(v-for="ecomm in ecommerce" :key="ecomm.title")
          v-divider.my-4
          v-layout.mx-4
            div.my-auto
              v-card.elevation-0
                v-img(:src="ecomm.image" width=28)
            div.my-auto.ml-3.body-2 {{ ecomm.title }}
            v-spacer
            v-chip.button-AA-tiny(v-if="ecomm.action === 'router-push'" label outlined color="black" small @click="setUp(ecomm.link)" ) MANAGE

      v-card.py-4.mt-4.mx-2(flat outlined)
        .header.px-4
          div.s1.basic800--text Domain
          div.c1.basic600--text Manage your domain for Whatsapp Form and Yezza Store
          //- div.c1.basic600--text(v-if="$store.state.subscriptions.feature === 'free'") Manage your domain for Donation Form

        v-divider.my-4
        v-layout.mx-4.mt-4
          div.my-auto.s1.basic800--text Custom Domain
          v-spacer
          v-chip.button-AA-tiny(label outlined color="black" small @click="openRequestCustDomain = true") MANAGE
        
        v-divider.my-4
        v-layout.mx-4.mt-4
          div.my-auto.s1.basic800--text Domain Verifications
          v-spacer
          v-chip.button-AA-tiny(label outlined color="black" small @click="openDomainVerifications = true") MANAGE
        
      v-card.py-4.mt-4.mx-2(flat outlined)
        v-layout.mx-4
          .header
            div.s1.basic800--text Webhook
            div.c1.basic600--text Webhook setting for API integration
            div.c1.accent--text(@click="openLink('w')") Learn More
          v-spacer
          v-chip.my-auto.button-AA-tiny(label outlined color="black" small @click="openWebhookDialog()") MANAGE
      
      .payment-gateway(v-if="Auth('component', '/admin/settings/advance#payment_gateway')")
        v-card.py-4.mt-4.mx-2(flat outlined)
          .header.px-4
            div.s1.basic800--text Payment Gateway
            div.c1.basic600--text Activate your choice of payment gateway
            div.c1.accent--text(@click="openLink('p')") Learn More
        online-payment-list.mx-2.mt-n1(:company="company")

    .modals
      update-trackers(v-if="showUpdateTrackersDialog" :open.sync="showUpdateTrackersDialog" :company.sync="company" :type="openTrackerType")
      update-webhook(v-if="showUpdateWebhookDialog" :open.sync="showUpdateWebhookDialog" :company="company")
      request-custom-domain(v-if="openRequestCustDomain" :open.sync="openRequestCustDomain" :company="company")
      domain-verifications(v-if="openDomainVerifications" :open.sync="openDomainVerifications" :company="company")

</template>

<script>
import { mapActions } from 'vuex'
import UpdateTrackers from '@/components/dialogs/settings/UpdateTrackers.vue'
import UpdateWebhook from '@/components/dialogs/settings/UpdateWebhook.vue'
import RequestCustomDomain from '@/components/dialogs/RequestCustomDomain.vue'
import DomainVerifications from '@/components/dialogs/DomainVerifications.vue'
import OnlinePaymentList from '@/components/settings/OnlinePaymentList.vue'

export default {
  name: 'AdvanceConfigurationSettings',
  components: { UpdateTrackers, UpdateWebhook, RequestCustomDomain, DomainVerifications, OnlinePaymentList },
  props: ['company'],
  data () {
    return {
      showUpdateTrackersDialog: false,
      showUpdateWebhookDialog: false,
      openRequestCustDomain: false,
      openDomainVerifications: false,
      openTrackerType: '',
      ecommerce: [
        { title: 'WooCommerce', image: require('@/assets/images/settings/logo_woocommerce.svg'), link: '/admin/settings/woocommerce', action: 'router-push' },
        // { title: 'Magento', image: require('@/assets/images/magento-logo-square.png'), link: '/admin/settings/woocommerce', action: 'dialog' },
        { title: 'Shopify', image: require('@/assets/images/settings/logo_shopify.svg'), link: '/admin/settings/shopify', action: 'router-push' },
      ],
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openLink (link) {
      if (link === 'w') {
        window.open('https://guide.yezza.io/eng/tips-use-webhook/')
      } else if (link === 'a' ) {
        window.open('https://help.yezza.io/hc/en-my/sections/900000600066-Analytics')
      } else if (link === 'p' ) {
        window.open('https://help.yezza.io/hc/en-my/categories/900000227246-Accept-Payments')
      } else {
        window.open('https://help.yezza.io/hc/en-my/articles/900003297906-How-To-Integrate-Yezza-With-WooCommerce-')
      }
    },
    setUp (path) {
      if (!this.Auth('root', 'e_commerce_integrations')) {
        this.showMessage(['upgrade'])
        return
      }
      this.$router.push(path)
    },
    openTrackerDialog (type) {
      this.openTrackerType = type
      this.showUpdateTrackersDialog = true
    },
    openWebhookDialog () {
      //this.openTrackerType = type
      this.showUpdateWebhookDialog = true
    },
  }
}
</script>

<i18n>
{
  "en": {
    "company_details": "Company Details",
    "company_description": "This informations will be used in your company invoice"
  },
  "ms": {
    "test": "Assalamualaikum"
  }
}
</i18n>